import { render, staticRenderFns } from "./IndustryBar.vue?vue&type=template&id=70b1bb52"
import script from "./IndustryBar.vue?vue&type=script&lang=js"
export * from "./IndustryBar.vue?vue&type=script&lang=js"
import style0 from "./IndustryBar.vue?vue&type=style&index=0&id=70b1bb52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports